import { baseEntity } from 'mocks/server/data/generation/generateBaseEntity';
import { broadsignFrame, formatSize } from 'mocks/server/data/generation/generateDetails';
import { ILiveFrame } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { LiveStatus } from 'utils/statuses';

const BASE_FRAME_ID = '1000000000';

export const baseFrame: ILiveFrame = {
  ...baseEntity(EntityType.FRAME, BASE_FRAME_ID),
  status: LiveStatus.ACTIVE,
  broadsignFrames: [broadsignFrame(), broadsignFrame(), broadsignFrame()],
  hasDraft: false,
};

export const frameThatFailsToDeactivate: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToDeactivateFrame',
  name: 'failToDeactivateFrame',
  status: LiveStatus.ACTIVE,
};

export const frameThatFailsToDeactivate2: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToDeactivateFrame2',
  name: 'failToDeactivateFrame2',
  status: LiveStatus.ACTIVE,
};

export const frameThatFailsToDeactivateNoDraft: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToDeactivateFrameNoDraft',
  name: 'failToDeactivateFrameNoDraft',
  status: LiveStatus.ACTIVE,
};

export const frameThatFailsToDeactivateNoDraft2: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToDeactivateFrameNoDraft2',
  name: 'failToDeactivateFrameNoDraft2',
  status: LiveStatus.ACTIVE,
};

export const frameThatFailsToArchive: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToArchiveFrame',
  name: 'failToArchiveFrame',
  status: LiveStatus.INACTIVE,
};

export const frameThatFailsToArchiveNoDraft: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToArchiveFrameNoDraft',
  name: 'failToArchiveFrameNoDraft',
  status: LiveStatus.INACTIVE,
};

export const frameThatFailsToActivate: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToActivateFrame',
  name: 'failToActivateFrame',
  status: LiveStatus.INACTIVE,
};

export const frameThatFailsToActivateNoDraft: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToActivateFrameNoDraft',
  name: 'failToActivateFrameNoDraft',
  status: LiveStatus.INACTIVE,
};

export const frameThatFailsToUnarchive: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToUnarchiveFrame',
  name: 'failToUnarchiveFrame',
  status: LiveStatus.ARCHIVED,
};

export const frameThatFailsToUnarchiveNoDraft: ILiveFrame = {
  ...baseFrame,
  spaceId: 'failToUnarchiveFrameNoDraft',
  name: 'failToUnarchiveFrameNoDraft',
  status: LiveStatus.ARCHIVED,
};

export const inactiveFrame: ILiveFrame = {
  ...baseFrame,
  spaceId: 'inactiveFrame',
  status: LiveStatus.INACTIVE,
};

export const archivedFrame: ILiveFrame = {
  ...baseFrame,
  spaceId: 'archivedFrame',
  status: LiveStatus.ARCHIVED,
};

export const frameWithLongName: ILiveFrame = {
  ...baseFrame,
  spaceId: '1111111111',
  name: 'This is a very long name to show an example of how the app deals with really long names',
  mediaOwnerName: 'All City Media Solutions',
  environment: 'MotorwayServiceStation',
  formatSize: formatSize(),
  status: LiveStatus.ACTIVE,
  broadsignFrames: [
    broadsignFrame(),
    broadsignFrame(),
    broadsignFrame(),
    broadsignFrame(),
    broadsignFrame(),
    broadsignFrame(),
    broadsignFrame(),
    broadsignFrame(),
  ],
};

export const frameWithMultipleConsolidatedResolutions: ILiveFrame = {
  ...baseFrame,
  spaceId: 'MultiCResolutions',
  status: LiveStatus.ACTIVE,
  consolidatedResolutions: ['1280x720', '2560x1440', '3840x2160'],
};

export const frameWithDraft: ILiveFrame = {
  ...baseFrame,
  spaceId: 'frameWithDraft',
  status: LiveStatus.ACTIVE,
  hasDraft: true,
};

export const frames: ILiveFrame[] = [
  frameThatFailsToDeactivate,
  frameThatFailsToDeactivate2,
  frameThatFailsToDeactivateNoDraft,
  frameThatFailsToDeactivateNoDraft2,
  frameThatFailsToActivate,
  frameThatFailsToActivateNoDraft,
  frameThatFailsToUnarchive,
  frameThatFailsToUnarchiveNoDraft,
  frameThatFailsToArchive,
  frameThatFailsToArchiveNoDraft,
  inactiveFrame,
  archivedFrame,
  frameWithLongName,
  frameWithMultipleConsolidatedResolutions,
  frameWithDraft,
  baseFrame,
];
